/**
 * 
 * configuration of our filters
 */
app.provider("_$filter",function(){
    
    var path;
    
    this.setPath=function(p){
    
        path=p;
        
    };
    
    
    this.$get=function(){
      
        return new function(){
            
            this.filters={};
            
            this.add=function(symbol,filter){
              
                this.filters[symbol]=filter;
                
            };
            
            this.get=function(symbol){
              
                return this.filters[symbol];
            };
          
            this.getPath=function(){
                
                return path;
            
            };
            
        };
        
    };
    
    
});


